import { Outlet, useLocation } from "react-router-dom";
import { PageEnum, TABLEPAI, LMD_TABLE_HEADER } from "@/enums/pageEnum";
import { useTranslation } from "react-i18next";
import { BasicTable, HView, Status } from "@/components";

export default function Lmd() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (pathname !== PageEnum.LMD) return <Outlet />;
  return (
    <div className="p-4">
      <BasicTable
        filterTableFields={[
          {
            field: "name",
            label: t("lmd"),
            keys: ["tc", "pfx", "blk"],
            component: "groupTexts",
            labelCol: { span: 3 },
            wrapperCol: { span: 21 },
          },
          { field: "clientId", label: t("lMDID"), component: "text" },
          { field: "postalCode", label: t("postalCode"), component: "text" },
          {
            field: "softwareVersion",
            label: t("software"),
            apiUrl: "/api/lmd/software/versions",
            component: "apiSelect",
            fieldProps: { popupClassName: "codeClassName" },
          },
        ]}
        tableColsRender={[
          {
            dataIndex: "onlineFormat",
            renderText: (text: string) => <Status status={text} />,
          },
          {
            title: t("action"),
            dataIndex: "action",
            renderText: (_: string, record: { id: string }) => (
              <HView
                name={t("view")}
                path={`${PageEnum.LMD}/detail/${record?.id}`}
                state={record}
              />
            ),
          },
        ]}
        tableName="lmd"
        longPolling
        isShowCheckbox={false}
        editTableHeaderUrl={LMD_TABLE_HEADER}
        headerTitle={() => t("lmdList")}
        requestUrl={TABLEPAI.LMD_PAGE}
      />
    </div>
  );
}
